import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Archivistico_item } from "../../../../json/irpadArchivisticoSESA";


const ArchivisticoSESA = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="container transparencia-container">
      <div className="row">
        <div className="col-12">
          <div className="transparencia_title">
            <h1>Informe de Resultados del Programa Anual de Desarrollo Archivístico (PADA) Secretaría de Salud</h1>
            <hr className="tramitehr" />
          </div>
        </div>
      </div>
      <div className="row">
      <ul>
          {Archivistico_item.map((item, index) => (
            <li key={index}>
                 <span className="badge bg-primary">
                  .pdf
                </span>   
              <a href={item.archivistico_item_url} target="_blank" rel="noopener noreferrer">{item.archivistico_item_nombre}</a>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default ArchivisticoSESA;
